module.exports = __webpack_public_path__ + "static/media/Magento-logo.b7f762de.png";